export const INITIAL_EDITOR_CONTENT = `<h2 style="text-align: center; color: #2c3e50; font-size: 28px; margin-bottom: 20px;">
  <span style="color: #3498db; text-decoration: underline; font-weight: bold;">✨ Click here</span>
  <strong> to start using the </strong>
  <span style="color: #e74c3c; font-style: italic; font-weight: bold;">HTML editor online</span>
  <span style="color: #f39c12; font-size: 32px;"> 🚀</span>
</h2>
<div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 20px; border-radius: 10px; margin: 20px 0;">
  <p style="color: white; font-size: 16px; line-height: 1.6; margin: 0;">
    <strong style="color: #ffd700;">👉 Please try out</strong> the <span style="background-color: rgba(255,255,255,0.2); padding: 2px 6px; border-radius: 4px;">WYSIWYG HTML editor</span> features found in the kitchen sink above to edit and format your text and images
  </p>
</div>
<p style="background-color: #ecf0f1; padding: 15px; border-left: 4px solid #3498db; border-radius: 5px; color: #34495e; font-size: 15px;">
  <strong style="color: #2980b9;">💡 Pro Tip:</strong> You'll see the content created in the WYSIWYG-HTML editor in <span style="background-color: #2c3e50; color: #2ecc71; padding: 2px 8px; border-radius: 3px; font-family: monospace;">&lt;source code&gt;</span> format on the right.
</p>
<hr style="border: none; height: 2px; background: linear-gradient(to right, #3498db, #e74c3c, #f39c12, #2ecc71); margin: 20px 0;">
<p style="text-align: center; color: #95a5a6; font-style: italic;">
  Start creating amazing content now! ✍️
</p>`

